import { FULL_HD, HD, safetyMargins } from '@bedrock-rdk/constants';
import { PRIMARY, TERTIARY, UTILITY1, UTILITY2, UTILITY3, UTILITY4, makeThemeColor } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { ICON_COLLECTION } from '@tornado-rdk/icons';
import { makeDefaultStylingContext } from '../utils/style';
import { identity } from '../utils/sizes';
import { NOTIFICATION_LEVEL } from '../notifications';

export const defaultContext = makeDefaultStylingContext();

const tertiary = makeThemeColor(TERTIARY);

export const colors = {
  text: {
    [NOTIFICATION_LEVEL.SYSTEM]: tertiary,
    [NOTIFICATION_LEVEL.SUCCESS]: tertiary,
    [NOTIFICATION_LEVEL.WARNING]: tertiary,
    [NOTIFICATION_LEVEL.ERROR]: makeThemeColor(PRIMARY),
  },
  background: {
    [NOTIFICATION_LEVEL.SYSTEM]: makeThemeColor(UTILITY4),
    [NOTIFICATION_LEVEL.SUCCESS]: makeThemeColor(UTILITY2),
    [NOTIFICATION_LEVEL.WARNING]: makeThemeColor(UTILITY3),
    [NOTIFICATION_LEVEL.ERROR]: makeThemeColor(UTILITY1),
  },
};

export const HEIGHT = {
  [FULL_HD]: 68 + safetyMargins.vertical[FULL_HD],
  [HD]: 64 + safetyMargins.vertical[HD],
};

export const ICON_SIZE = {
  [FULL_HD]: 32,
  [HD]: 32,
};

export const ICON_MARGIN_RIGHT = {
  [FULL_HD]: 16,
  [HD]: 16,
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const h = HEIGHT[screenSize];

  return {
    h,
    Content: {
      w: identity,
      h,
      y: h,
      color: colors.background[NOTIFICATION_LEVEL.SYSTEM][colorMode],
      Inner: {
        w: identity,
        h: h - safetyMargins.vertical[screenSize],
        Icon: {
          iconData: {
            picto: {
              name: 'CheckFocused',
              collection: ICON_COLLECTION.BASIC,
            },
            viewBox: {
              h: ICON_SIZE[screenSize],
            },
          },
          color: colors.text[NOTIFICATION_LEVEL.SYSTEM][colorMode],
          flexItem: {
            marginRight: ICON_MARGIN_RIGHT[screenSize],
          },
        },
        Caption: {
          text: {
            ...getFont(FONT.OTTAWA_2),
            verticalAlign: 'middle',
            textColor: colors.text[NOTIFICATION_LEVEL.SYSTEM][colorMode],
          },
        },
        flex: {
          direction: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
    },
  };
};
